/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Library_Tab_WorkoutsInputs */

const en_library_tab_workouts = /** @type {(inputs: Library_Tab_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workouts`)
};

const pl_library_tab_workouts = /** @type {(inputs: Library_Tab_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningi`)
};

/**
* | output |
* | --- |
* | "Workouts" |
*
* @param {Library_Tab_WorkoutsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const library_tab_workouts = /** @type {((inputs?: Library_Tab_WorkoutsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Library_Tab_WorkoutsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_library_tab_workouts(inputs)
	return en_library_tab_workouts(inputs)
});